import { gql } from "graphql-tag";

export const GET_WMS_SYNC_STATUS = gql`
	query WmsSyncStatus {
		wms_sync_status
	}
`;

// calls between the shop and Smart WMS (list columns; bodies via GET_WMS_WEBHOOK_LOG)
export const GET_WMS_WEBHOOK_LOGS = gql`
	query WmsWebhookLogs($page: Int, $limit: Int, $direction: String, $entity: String, $status: String, $search: String, $date_from: String, $date_to: String) {
		wms_webhook_logs(page: $page, limit: $limit, direction: $direction, entity: $entity, status: $status, search: $search, date_from: $date_from, date_to: $date_to) {
			total
			per_page
			current_page
			from
			to
			last_page
			has_more_pages
			data {
				id
				direction
				entity
				action
				method
				url
				response_status
				status
				error
				records
				order_id
				attempt
				resent_from_id
				resent_by
				duration_ms
				created_at
				can_resend
			}
		}
	}
`;

// one call with request and response (JSON string)
export const GET_WMS_WEBHOOK_LOG = gql`
	query WmsWebhookLog($id: Int!) {
		wms_webhook_log(id: $id)
	}
`;
